import { render, staticRenderFns } from "./NewslettersV2.vue?vue&type=template&id=2dace391&scoped=true&"
import script from "./NewslettersV2.vue?vue&type=script&lang=js&"
export * from "./NewslettersV2.vue?vue&type=script&lang=js&"
import style0 from "./NewslettersV2.vue?vue&type=style&index=0&id=2dace391&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dace391",
  null
  
)

export default component.exports